@if (hasFavorite()) {
  <ion-card class="app-background">
    <ion-card-header class="ion-no-padding">
      <ion-item-divider>
        <ion-label class="text-dark-500 text-bold">{{ title() }}</ion-label>
      </ion-item-divider>
    </ion-card-header>

    <ion-card-content class="ion-no-padding">
      @for (favInstallation of data(); track favInstallation.id) {
        <ion-row
          class="list-padding cursor-pointer"
          (click)="navigateInstallation(favInstallation.id)"
        >
          <ion-col
            size="3"
            class="center-item bg-grey text-grey-600 ion-no-padding"
          >
            <ion-icon
              name="{{ favInstallation.icon ? favInstallation.icon : 'home' }}"
              class="icon-x2"
            ></ion-icon>
          </ion-col>
          <ion-col size="9" class="ion-no-padding ion-padding-horizontal">
            <ion-card-header class="pt-05 pb-05 list-text-list ion-no-padding">
              <div class="text-grey">
                {{ favInstallation.name ? favInstallation.name : '-' }}
              </div>
              <div class="text-grey">
                {{
                  favInstallation.addressLine1
                    ? favInstallation.addressLine1
                    : '-'
                }}
              </div>
              <div class="text-grey">
                {{
                  favInstallation.postalCode
                    ? favInstallation.postalCode + ' ' + favInstallation.city
                    : favInstallation.city
                }}
              </div>
            </ion-card-header>
          </ion-col>
        </ion-row>
      }
    </ion-card-content>
  </ion-card>
} @else {
  <!-- show no favorite installation message -->

  <ion-card class="app-background">
    <ion-card-header class="ion-no-padding ion-padding-bottom">
      <ion-item-divider>
        <ion-label class="text-dark-500 text-bold">{{ title() }}</ion-label>
      </ion-item-divider>
    </ion-card-header>

    <ion-card-content class="ion-padding">
      <div class="ion-padding panel-border">
        <div>
          <strong>{{ 'dashboard_favorites_empty' | translate }}</strong>
          {{ 'dashboard_favorites_empty_info' | translate }}
        </div>
      </div>
    </ion-card-content>
  </ion-card>
}
